import BaseExecutor from 'services/sports/default/base-executor';
import Action from 'actions';
import BaseValidator from 'services/validations/base-validator';
import ProjectedOwnershipForceValidator from 'components/organisms/projected-ownership-force/validators/validator';
import {CorrelationStackingValidatorBuilder} from 'services/sports/nfl/validator/correlation-stacking-validator-builder';
import {ClassicValidatorBuilder} from 'services/validations/builders/classic-validator-builder';
import LockedGamesValidator from 'services/validations/locked-games-validator';

export default class UserAdjustmentsValidatorClassicBuilder extends BaseExecutor {
    getInterface() {
        const {
            sportConfig,
            projectedOwnershipForce,
            playersData: {preparedPlayers, games},
        } = Action.getState();

        const validator = new BaseValidator();

        const classicValidatorBuilder = new ClassicValidatorBuilder().getInterface();
        validator.addSubValidators([classicValidatorBuilder]);

        if (sportConfig.isModeLateswap()) {
            const lockedGamesValidator = new LockedGamesValidator();
            lockedGamesValidator.setDependencies({games});
            validator.addSubValidators([lockedGamesValidator]);
        }

        if (projectedOwnershipForce.isEnabled()) {
            const projectedOwnershipForceValidator = new ProjectedOwnershipForceValidator();
            projectedOwnershipForceValidator.setDependencies({
                sportConfig,
                projectedOwnershipForce,
                players: preparedPlayers.groupedBy.playerId(),
            });
            validator.addSubValidators([projectedOwnershipForceValidator]);
        }

        const correlationStackingValidator = new CorrelationStackingValidatorBuilder().getInterface();
        validator.addSubValidators([correlationStackingValidator]);

        return validator;
    }
}
